const { makeStyles } = require("@material-ui/core");

export const layoutWrapperStyle = makeStyles((theme) => ({
    card: {
        margin: "-35px -40px",
    }
}))